// extracted by mini-css-extract-plugin
module.exports = {"outcome":"Outcomes_outcome__2xGQc","outcomeName":"Outcomes_outcomeName__R8OKE","selected":"Outcomes_selected__1pvOT"};